module.exports = __webpack_public_path__ + "media/images/pg-top/fv-0f6bb3e13ff7512e6295a355a2a7a02b.png";